// src/pages/Builders/ERPManagement.jsx
import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../../layout/builders/Layout";
import VendorTab from "../../layout/builders/ERP/VendorTab";
import EmployeeTab from "../../layout/builders/ERP/EmployeeTab";
import FinanceTab from "../../layout/builders/ERP/FinanceTab";
import InventoryTab from "../../layout/builders/ERP/InventoryTab";
import PettyCashTab from "../../layout/builders/ERP/PettyCashTab";
import ProjectInchargeTab from "../../layout/builders/ERP/ProjectInchargeTab";
import ERPAttendanceTab from "../../layout/builders/ERP/ERPAttendanceTab";
import ERPWeeklyUpdateTab from "../../layout/builders/ERP/ERPWeeklyUpdateTab";
import {
  Building2,
  Users,
  BarChart3,
  Package,
  Wallet,
  ShieldCheck,
  CalendarDays,
  ClipboardList,
} from "lucide-react";

const TAB_CONFIG = [
  { key: "vendor", label: "Vendor", icon: Building2, color: "text-blue-600", bg: "bg-blue-50" },
  { key: "employee", label: "Employee", icon: Users, color: "text-orange-600", bg: "bg-orange-50" },
  { key: "finance", label: "Finance", icon: BarChart3, color: "text-green-600", bg: "bg-green-50" },
  { key: "inventory", label: "Inventory", icon: Package, color: "text-purple-600", bg: "bg-purple-50" },
  { key: "petty-cash", label: "Petty Cash", icon: Wallet, color: "text-red-600", bg: "bg-red-50" },
  { key: "project-incharge", label: "Users", icon: ShieldCheck, color: "text-blue-600", bg: "bg-blue-50" },
  { key: "attendance", label: "Attendance", icon: CalendarDays, color: "text-indigo-600", bg: "bg-indigo-50" },
  { key: "weekly-update", label: "Weekly Update", icon: ClipboardList, color: "text-violet-600", bg: "bg-violet-50" },
];

const ERPManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab") || "vendor";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  useEffect(() => {
    const urlTab = searchParams.get("tab") || "vendor";
    if (urlTab !== activeTab) setActiveTab(urlTab);
  }, [searchParams, activeTab]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "vendor": return <VendorTab />;
      case "employee": return <EmployeeTab />;
      case "finance": return <FinanceTab />;
      case "inventory": return <InventoryTab />;
      case "petty-cash": return <PettyCashTab />;
      case "project-incharge": return <ProjectInchargeTab />;
      case "attendance": return <ERPAttendanceTab />;
      case "weekly-update": return <ERPWeeklyUpdateTab />;
      default: return <VendorTab />;
    }
  };

  return (
    <Layout>
      <div className="space-y-4 w-full">
        {/* Header Card - Simplified */}
        <div className="bg-white p-3 sm:p-4 rounded-lg shadow-sm border w-full max-w-full">
          <h1 className="text-lg sm:text-xl font-bold text-gray-800">ERP Management</h1>
        </div>

        {/* Tab Navigation - Pill Style matching ProjectManagement */}
        <div className="bg-white p-2 sm:p-3 rounded-lg shadow-sm border w-full max-w-full overflow-hidden">
          <div className="flex gap-2 sm:gap-3 overflow-x-auto pb-1 scrollbar-hide">
            {TAB_CONFIG.map((tab) => {
              const active = activeTab === tab.key;
              const Icon = tab.icon;
              return (
                <button
                  key={tab.key}
                  onClick={() => handleTabChange(tab.key)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full whitespace-nowrap text-xs sm:text-sm flex-shrink-0 transition-all duration-200 ${active
                    ? "bg-blue-100 text-blue-600 font-semibold"
                    : "text-gray-600 hover:bg-gray-100"
                    }`}
                >
                  <Icon size={16} className={active ? "text-blue-600" : "text-gray-400"} />
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Tab Content */}
        <div className="w-full max-w-full overflow-hidden">
          {renderTabContent()}
        </div>
      </div>
    </Layout>
  );
};

export default ERPManagement;
